import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { environment } from '@environments/environment';

import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAURLService } from '@ibe.services/url.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';


@Component({
	selector: 'app-ancillary-block-offer',
	templateUrl: './ancillary-block-offer.indra.component.html',
	styleUrls: ['./ancillary-block-offer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class INDRAAncillaryBlockOfferComponent implements OnInit {

	private _ancillary: any;
	INSURANCE = 'INSURANCE';

	@Input() isLoading = true;
	@Input() showDescription = false;

	@Input()
	set ancillary(data) {
		this._ancillary = { ...data };	
		/* if (!this._ancillary.provider) {
			this._ancillary.provider = Object.assign({}, this._ancillary.provider, {
				name: 'Booking', logo: 'sprite.svg#partners--booking', label_prefix: '', label_sufix: ''
			});
			this._ancillary = Object.assign({}, this._ancillary, { image: this._ancillary.photo.url_original, title: this._ancillary.hotel_name });
		} */
	}

	currency;

	constructor(
		private sanitizer: DomSanitizer, 
		private cdr: ChangeDetectorRef,
		private ibeAdminService: INDRAIbeAdminService,
		private urlService: INDRAURLService,
		private currencyService: INDRACurrencyService) {
	}
	
	/**
	 * Prints title of ancillary
	 */
	INDRA_printTitle(): string {
		if(this._ancillary.type === this.INSURANCE){
			return this.ibeAdminService.getTranslationValue('bookingDetails.title.insurance')
		}
		return this._ancillary.title;
	}

	/**
	 * Prints ancillary description
	 */
	INDRA_printDescription(): string {
		return this._ancillary.description;
	}

	/**
	 * Prints ancillary cost
	 * Cost converted to environment/market format
	 */
	INDRA_printCost(): string {
		const CAR = 'CAR';
		if (this._ancillary.type === this.INSURANCE || this._ancillary.type == 'tours' || this._ancillary.type == 'nanny' || this._ancillary.type == 'cruise' || this._ancillary.type == 'eSIM') {
		 	
			return (this._ancillary.type === this.INSURANCE || this._ancillary.type == 'tours' || this._ancillary.type == 'nanny' || this._ancillary.type == 'cruise' || this._ancillary.type == 'eSIM' ?
				(this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this.ibeAdminService.getTranslationValue('bookingDetails.label.from') + ' ' : '' : '')
				+ ((this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this._ancillary.data.price + ' ' + this.currency : '');
		}

		return ((this._ancillary.type === CAR  ?
			(this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this.ibeAdminService.getTranslationValue('bookingDetails.label.from') + ' ' : '' : '')
			+ ((this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this._ancillary.data.price  + ' ' + this.currency : '')
			+ 
			(this._ancillary.type == CAR || this._ancillary.type == 'parking' || this._ancillary.type == 'assistance' ?
			(this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00' ? ' ' + this.ibeAdminService.getTranslationValue('bookingDetails.label.perDay') : '') :
			this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00' ? ' ' + this.ibeAdminService.getTranslationValue('bookingDetails.label.perNight') : ''));
	}

	/**
	 * Prints ancillary provider prefix
	 */
	INDRA_printProviderPrefix(): string {
		return this._ancillary.label_prefix;
	}

	/**
	 * Prints ancillary provider name
	 */
	INDRA_printProvider(): string {
		return this._ancillary.name;
	}

	/**
	 * Prints ancillary provider sufix
	 */
	INDRA_printProviderSufix(): string {
		return this._ancillary.label_sufix;
	}

	/**
	 * Prints ancillary cta button label
	 */
	INDRA_printButtonLabel(): string {
		return this._ancillary.cta;
	}

	/**
	 * Prints ancillary image url
	 */
	INDRA_printImage(): SafeStyle {
		return this.sanitizer.bypassSecurityTrustStyle(`url(${this._ancillary.image})`);
	}

	INDRA_printPartnerLogo(): string {
		return this._ancillary.logo;
	}

	/**
	 * Checks if ancillary as stars
	 */
	INDRA_hasStars(): boolean {
		return this._ancillary.stars;
	}
	
	/**
	 * Prints all filled or empty stars
	 * @param type of stars to print - 'full' | 'empty'
	 */
	INDRA_printStar() {
		return this._ancillary.stars
	}

	/**
	 * Prints ancillary type
	 */
	INDRA_printType(): string {
		return this._ancillary.type;
	}

	INDRA_hasDiscount() {
		return this._ancillary.discount;
	}

	INDRA_printDiscount() {
		return this._ancillary.discount;
	}

	INDRA_ariaLabel() {
		let label = '';
		label += this.INDRA_getTextTranslation('bookingDetails.aria.listBookingContacts') + " " + this.INDRA_printType() + ': ';
		label += this.INDRA_printTitle() + ', ';
		label += this.INDRA_printCost() + ', ';
		label += this.INDRA_getTextTranslation('bookingDetails.aria.inPartnershipWith') + this._ancillary.provider + '.';
		if (this.INDRA_hasDiscount()) {
			label += this.INDRA_getTextTranslation('bookingDetails.aria.with') + this.INDRA_printDiscount() + this.INDRA_getTextTranslation('bookingDetails.aria.discount');
		}

		return label;
	}
	
	INDRA_redirectTo() {
		let link = this._ancillary.link;
		link = this.urlService.INDRA_updateMaskedField(link, 'LANG_MASK', sessionStorage.getItem('language'));
		link = this.urlService.INDRA_getEscapedUrl(link);
		window.open(link,
			'_blank' // <- This is what makes it open in a new window.
		);
	}
	
	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	ngOnInit() {

		// setTimeout(() => {
			this.isLoading = false;
			this.cdr.markForCheck();
		// }, 3000);

		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
	}

}
